import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WizardExportModule } from '@barthauer/abc/interfaces/core/wizards/wizard-export';
import { GisExportComponent } from './gis-export.component';
import { MatRadioModule } from '@angular/material/radio';
import { AbcUiComponentsModule } from '@barthauer/abc/ui-components';
import { ExportModeSelectionPageComponent } from './pages/export-mode-selection-page/export-mode-selection-page.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@NgModule({
  imports: [
    CommonModule,
    WizardExportModule,
    MatRadioModule,
    AbcUiComponentsModule,
    MatIconModule,
    MatButtonModule,
    MatButtonToggleModule,
  ],
  declarations: [GisExportComponent, ExportModeSelectionPageComponent],
})
export class GisExportModule {}
